export default __webpack_public_path__ + "img/Inter-Italic_6d7a749.woff2";